export default __webpack_public_path__ + "static/media/ZWINNOSC.7666e5ce.png";